import { DateTime } from 'luxon';

/**
 * Day-strip / outlook / moon-phase label: "Today" for the current local day,
 * otherwise weekday + calendar day without a leading zero (e.g. "Tue 19").
 */
export const formatWeatherForecastDayLabel = (
  date: DateTime,
  isToday: boolean,
): string => {
  if (!date.isValid) {
    return '';
  }

  if (isToday) {
    return 'Today';
  }

  return date.toFormat('ccc d');
};
